function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP licence number
 * 
 */
import React from 'react';
import { connect } from 'react-redux';
import { licenceClass } from '../../actions/index';
import Select from '../select/Select';
import { LICENCE_CLASS } from '../../data/Data';
import './LicenceClass.scss';
import { jsx as _jsx } from "react/jsx-runtime";
const LICENCE_CLASS_INFO = 'Select the highest motor vehicle or motorcycle licence class currently held – this will be reflected on your permit. Learner and restricted licence holders cannot apply for a permit. <a href="https://www.aaa.asn.au/IDP-exceptions" target="_blank">View all licence restrictions (PDF, 116 KB).</a>';
export class LicenceClass extends React.Component {
  render() {
    const {
      licenceClass,
      setLicenceClass
    } = this.props;
    return /*#__PURE__*/_jsx(Select, {
      label: "Licence class",
      options: LICENCE_CLASS,
      name: "licenceClass",
      info: LICENCE_CLASS_INFO,
      section: "licence-details",
      handleChange: setLicenceClass,
      onBlur: setLicenceClass
      // $FlowFixMe
      ,
      values: {
        licenceClass
      }
    });
  }
}
_defineProperty(LicenceClass, "defaultProps", {
  licenceClass: {
    error: false,
    required: true,
    valid: null,
    value: ''
  }
});
const mapStateToProps = ({
  licenceClass
}) => {
  return {
    licenceClass
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setLicenceClass: value => {
      dispatch(licenceClass(value));
    }
  };
};
const VisibleLicenceClass = connect(mapStateToProps, mapDispatchToProps)(LicenceClass);
export default VisibleLicenceClass;